import React from 'react';
import { createRoot } from 'react-dom/client';
import {BrowserRouter, Routes, Route, Navigate, useParams} from 'react-router-dom';
import {observer, Provider} from 'mobx-react';
import $ from 'jquery';
import config from 'config';
import {ScrollToTop, ErrorPage, history} from 'fn-common-ui';
import '../styles/app.scss';
import {utilsService} from './core/services/utils.service';

import {masterStore} from './core/stores/master.store.js';

import Footer from './components/footer';
import Header from './components/header/header';

import AddEditPage from './pages/add-edit-page';
import TrainingPortalPage from './pages/training-portal-page';

/* ATT Adobe: Part 3/3: Define docReady() callback to push events to DataManager
when their triggers are heard */
window.docReady = function() {
  console.log('[Adobe Analytics] docReady has been called')

  //Disable auto page load pushEvent, to cut over to our custom pushEvents
  if(window.ddo) {
    window.ddo.disableAutoPageLoad();
  }

  //Add a listener to send a pushEvent when an Adobe_Tag_Manager_Event is heard
  window.addEventListener('Adobe_Tag_Manager_Event', (event) => {
    if (window.ddo) {
      window.ddo.pushEvent(event.detail.evtAction, event.detail.evtName, event.detail.params);
    }
    console.log(`[Adobe Analytics] ${event.detail.evtAction} pushEvent formed`, event.detail.params);
  });

  // Possible Fix to run pageLoad evt on page refresh
  window.addEventListener('load', function() {
    if(window.ddo && localStorage.getItem('prevUrl') && localStorage.getItem('prevUrl') === this.location.href) {
      console.log('[Adobe Analytics] page reloaded, calling pageload ddo event');
      window.ddo.pushEvent('pageLoad', 'Page_Display', {
        'page.location.url': location.pathname.replace(/\s/g, ''),
        'user.login.id': masterStore.getUser().uid,
        'page.pageInfo.friendlyPageName':'fNet Training Home Pg',
        'page.pageInfo.flowCode': 'fNet~TrainingPortal'
      });
    }
    localStorage.removeItem('prevUrl');
  });
  
  window.addEventListener('beforeunload', function() {
    localStorage.setItem('prevUrl', location.href);
  })
}


// Trigger a Adobe_Tag_Manager_Event on route change
history.listen(({ location }) => {
  const params = {
    'page.location.url': location.pathname.replace(/\s/g, ''), //get rid of whitespace
    'user.login.id': masterStore.getUser().uid
  }
  utilsService.triggerCustomEvent('Adobe_Tag_Manager_Event', {
    evtAction: 'pageLoad',
    evtName: 'Page_Display',
    params
  });
});


@observer
class App extends React.Component {
  constructor(props) {
    super(props);
    masterStore.initSite();
  }

  componentDidMount() {
    document.addEventListener('keydown', function(e) {
      if (e.keyCode === 9) {
        $('body').addClass('show-focus-styles');
      }
    });

    document.addEventListener('click', function() {
      $('body').removeClass('show-focus-styles');
    });

    /* ATT Adobe: Part 2/3: Add footer script as late in lifecylcle as possible,
    which will call docReady() when DataManager is available */
    const script = document.createElement('script');
    script.src = 'https://www.att.com/scripts/adobe/stage/detm-container-ftr.js';
    document.body.appendChild(script);
  }

  renderLoading = () => {
    return (
      <main id="main-content">
        <div className="fn-loading">
          <div className="fn-loading-logo">
            <img
              src="/images/firstnet-logo.svg"
              width="173"
              height="51"
              alt="FirstNet logo" />
          </div>
          <h1 className="fn-loading-text">Loading</h1>
          <div className="fn-loading-circle">
            {[...Array(12)].map((x, i) => (
              <div key={i} className={`c${i + 1} c`} />
            ))}
          </div>
        </div>
      </main>
    );
  };

  renderErrorPage = (errorCause, config) => {
    if (errorCause === 'unauthorized') {
      return this.renderUnauthorizedErrorPage();
    } else {
      return <ErrorPage config={config} cause={errorCause} />;
    }
  };

  renderUnauthorizedErrorPage = () => {
    return (
      <ErrorPage
        config={config}
        currentPortal="Training Portal"
        userRoles={masterStore.userStore.user.roles}
        logoutUser={masterStore.userStore.logoutUser}
        cause="unauthorized" />
    );
  };

  renderLandingPageInAdminMode = (routeProps) => {
    masterStore.userStore.authenticateUserWithHalo();
    if (masterStore.userStore.isEditor) {
      masterStore.setIsAdmin(true);
      return <TrainingPortalPage {...routeProps} showAdminSubHeader={true} />;
    } else {
      return this.renderUnauthorizedErrorPage();
    }
  };

  mainLayoutRoutesComponent = () => {
    const self = this;
    function AdminRoute() {
      masterStore.userStore.authenticateUserWithHalo();
      if (masterStore.userStore.isEditor) {
        masterStore.setIsAdmin(true);
        return <TrainingPortalPage showAdminSubHeader={true} />;
      }
      return self.renderUnauthorizedErrorPage();
    }
    function ErrorRoute() {
      const { cause } = useParams();
      return self.renderErrorPage(cause, config);
    }
    return (
      <React.Fragment>
        <ScrollToTop path={history.location.pathname}>
          {masterStore.isLoggedIn && <Header store={masterStore} />}
          <main aria-label="Main Content." id="main-content">
            <Routes>
              <Route path="/" element={<TrainingPortalPage />} />
              <Route path="/admin" element={<AdminRoute />} />
              <Route
                path="/content/:mode/:sectionId/:contentItemId?"
                element={<AddEditPage />} />
              <Route
                path="/error/:cause"
                element={<ErrorRoute />} />
              <Route path="*" element={<Navigate to="/error/404" />} />
            </Routes>
          </main>
          {masterStore.isLoggedIn && <Footer />}
        </ScrollToTop>
      </React.Fragment>
    );
  };

  render() {
    return (
      <BrowserRouter>
        <Provider store={masterStore} user={masterStore.getUser()}>
          {masterStore.userStore.userValidationDone
            ? masterStore.isLoggedIn
              ? this.mainLayoutRoutesComponent()
              : this.renderUnauthorizedErrorPage()
            : this.renderLoading()}
        </Provider>
      </BrowserRouter>
    );
  }
}

const root = createRoot(document.getElementById('app'));
root.render(<App />);
